module.exports = __webpack_public_path__ + "static/img/image056.84db096.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image056.png
// module id = Ppd+
// module chunks = 1